import React from 'react';

import {MainLayout} from 'widgets/layout';

import {DomainMonitorDetails} from 'features/domain';

const DomainMonitorDetailsPage: React.FC = () => {
    return (
        <MainLayout>
            <DomainMonitorDetails />
        </MainLayout>
    );
};

export default DomainMonitorDetailsPage;
